import { Component, Input, ContentChild, TemplateRef } from "@angular/core";
import { ColumnAlign } from "../../types/table.types";

@Component({
  selector: "ds-column",
  template: "",
})
export class DsColumnComponent {
  @Input() name!: string;
  @Input() sortable = false;
  @Input() width: string;
  @Input() columnAlign: ColumnAlign = "start";
  @Input() headerRowspan: number | null = null;
  @Input() headerColspan: number | null = null;
  @Input() headerOnly = false;

  @ContentChild("dsHeader", { static: true }) dsHeader: TemplateRef<any>;
  @ContentChild("dsCell", { static: true }) dsCell: TemplateRef<any>;
}
